import React from "react";
import { Gift, Utensils, Dumbbell } from "lucide-react";
import { TID } from "@/lib/testIds";

export default function FreeGifts({ onBuy }) {
  return (
    <section className="relative bg-gradient-to-b from-black via-[#0a0603] to-black px-5 py-16 sm:py-20">
      <div className="mx-auto max-w-5xl">
        <div className="text-center">
          <div className="inline-flex items-center gap-2 rounded-full border border-[#FFC107]/30 bg-[#FFC107]/10 px-3 py-1 text-[11px] uppercase tracking-widest text-[#FFC107]">
            <Gift size={14} /> Exclusive Bonuses
          </div>
          <h2 className="mt-3 font-display text-4xl text-white sm:text-5xl">
            FREE GIFTS WORTH <span className="text-fire">₹3000</span>
          </h2>
          <p className="mt-2 text-sm text-neutral-400">
            Bundled free with every order today.
          </p>
        </div>

        <div className="mt-10 grid gap-4 sm:grid-cols-2">
          <div className="glass relative flex items-start gap-4 rounded-3xl p-6">
            <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-fire text-black">
              <Utensils size={26} />
            </div>
            <div>
              <div className="text-xs uppercase tracking-widest text-[#FFC107]">Bonus 1</div>
              <div className="mt-1 font-display text-2xl text-white">Customized Diet Plan</div>
              <p className="mt-1 text-sm text-neutral-400">
                Personalised meal plan tailored to your goals.
              </p>
              <div className="mt-2 text-xs">
                <span className="text-neutral-500 line-through">₹500</span>{" "}
                <span className="font-semibold text-[#FF7A00]">FREE</span>
              </div>
            </div>
          </div>
          <div className="glass relative flex items-start gap-4 rounded-3xl p-6">
            <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-fire text-black">
              <Dumbbell size={26} />
            </div>
            <div>
              <div className="text-xs uppercase tracking-widest text-[#FFC107]">Bonus 2</div>
              <div className="mt-1 font-display text-2xl text-white">Virtual Personal Trainer</div>
              <p className="mt-1 text-sm text-neutral-400">
                Guided workouts to complement your journey.
              </p>
              <div className="mt-2 text-xs">
                <span className="text-neutral-500 line-through">₹2500</span>{" "}
                <span className="font-semibold text-[#FF7A00]">FREE</span>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-10 rounded-3xl border border-[#FF7A00]/40 bg-gradient-to-br from-[#1a0d02] to-black p-6 text-center glow-orange-sm">
          <div className="text-xs uppercase tracking-[0.3em] text-neutral-400">Total Savings</div>
          <div className="mt-2 font-display text-5xl text-white sm:text-6xl">
            ₹<span className="text-fire">4251</span>
          </div>
          <div className="mt-1 text-sm text-neutral-400">
            ₹1251 discount + ₹3000 free bonuses when you order today
          </div>
          <button
            data-testid={TID.primaryBuyBtn}
            onClick={onBuy}
            className="mt-5 inline-flex w-full max-w-md items-center justify-center rounded-full bg-fire py-4 font-bold uppercase tracking-widest text-black animate-pulse-orange transition-transform hover:scale-[1.02] active:scale-[0.98]"
          >
            BUY NOW · Claim ₹3000 Bonuses
          </button>
          <div className="mt-3 flex flex-wrap items-center justify-center gap-3 text-[11px] uppercase tracking-widest text-neutral-500">
            <span>UPI</span>·<span>Visa</span>·<span>Mastercard</span>·<span>RuPay</span>·<span>COD</span>·<span>SSL Secure</span>
          </div>
        </div>
      </div>
    </section>
  );
}
